let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class CartService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
        this.cart = {};
    }

    addItemToCart(product, quantity, addItemAlreadyInCart1, isModalFastLoad, userId, cart) {

        return this.$q((resolve, reject) => {
            let addItemAlreadyInCart = addItemAlreadyInCart1 || 0;
            // Se valida la cantidad en local
            if (isNaN(quantity) || quantity < 1) {
                return resolve({
                    error: true,
                    message: 'Para agregar este producto al carrito de compras debe ingresar una cantidad valida.',
                    isHtml: false
                });
            }
            /* Declara la letiable itemCart */
            let itemCart = undefined;
            /* Si es definida la letiable global cart, recorre el arreglo de items adentro de la misma
            * y devuelve el objeto con la misma referencía en el carrito y el que se este agregando */
            if (cart) {
                itemCart = cart.items.filter(val => {
                    return val.reference === product.reference;
                })[0];
            }
            /* define la letiable itemCartQuantity => si itemCart esta definido, agrega la cantidad de ese item
            * en el carrito, Sino lo define en 0 */
            let itemCartQuantity = itemCart ? itemCart.quantity : 0;
            /* Define la letiable availableQuantity restando la cantidad del producto a comprar y la cantiadad del mismo
            * item en el carrito */
            let availableQuantity = parseInt(product.cantidad) - parseInt(itemCartQuantity);
            /* Si la cantidad disponible es negativa le indica a el usuario que hacer al respecto*/

            let currentItemId = product.id;

            let cartId = cart.cartId ? cart.cartId : this.SessionService.get('cartId') || '';
            let productId = product.id;
            if (product.clonedId) {
                currentItemId = product.clonedId;
                productId = product.clonedId;
            }
            let data = {
                'id_canasta': cartId,
                'userId': userId,
                'id_producto': productId,
                'cantidad_producto': quantity,
                'comentario_producto': '',
                'addItemAlreadyInCart': addItemAlreadyInCart
            };
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.addItemToCart,
                cache: true,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                if(!response.data.error){
                    this.SessionService.put('cartId', response.data.cartId);
                }
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    addProductToCartNew(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/agregar-item-canasta',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false,
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                if (!response.data.error) {
                    if (!data.id_canasta) {
                        this.saveCart(response.data.cartId);
                    }
                    resolve(response.data);
                } else {
                    reject(response.data.message);
                }

            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveCartOrderData(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.saveCartOrderData,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    locationBySearchText(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.locationBySearchText,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateCommentCart(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateCommentCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updatePayMethod(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updatePayMethod,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateQuantityItemCart(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateQuantityItemCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPayMethods(sellerId, userId,cartId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.payMethods + '?sellerId=' + sellerId + '&userId=' + userId + '&cartId='+cartId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPointsOfSale() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getPointsOfSale,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getInfoBillfoldState(thirdDocumentNumber, branchCode) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.B2B.BILLFOLD_RESUME +
                '?terceroDocumentoNumero=' + thirdDocumentNumber +
                '&sucursalCodigo=' + branchCode,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveCart(cart) {
        let token = btoa(cart + ':' + new Date());
        this.AuthTokenFactory.setToken('auth-cart', token);
        this.cart = cart;
    }

    clearCart(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.deleteCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                this.cart = {};
                this.cart.cartQuantity = 0;
                this.cart.cartTaxes = 0;
                this.cart.cartSubtotal = 0;
                this.cart.cartTotal = 0;
                this.cart.cartDiscounts = 0;
                this.cart.cartTransports = 0;
                this.cart.items = [];
                this.cart.order = {};
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getCart(cartId, userId, clientPriceListName, clear, url, login) {

        return this.$q((resolve, reject) => {
            if (this.cart && this.cart.cartId && !clear && cartId === this.cart.cartId) {
                resolve(this.cart);
            } else {

                this.$http({
                    method: 'GET',
                    url: url ? url : this.ngAuthSettings.apiServiceBaseUri + '/cart/obtener-canasta?cartId=' + cartId + '&userId=' + userId + '&quotePriceListName=' + clientPriceListName,
                    cache: false
                }).then((response) => {

                    if (!response.data.error) {
                        this.SessionService.put('cartId', response.data.cartId);
                        response.data.items = [];
                        response.data.order = {};
                        // Se actualiza la información del item almacenado
                        if (!response.data.itemsCanastaUsuario) response.data.itemsCanastaUsuario = [];
                        response.data.itemsCanastaUsuario.forEach(dato => {
                            response.data.items.push(dato);
                        });
                        response.data.cartQuantity = response.data.cartQuantity || 0;
                        response.data.cartTaxes = response.data.cartTaxes || 0;
                        response.data.cartSubtotal = response.data.cartSubtotal || 0;
                        response.data.cartTotal = response.data.cartTotal || 0;
                        response.data.cartDiscounts = response.data.cartDiscounts || 0;
                        response.data.cartTransports = response.data.cartTransports || 0;

                        response.data.order = response.data.cartOrderData || {};
                        response.data.order.cantidadTotalCanasta = 0;
                        response.data.order.vehiculo_transporte = {};
                        response.data.items.forEach(item => {
                            response.data.order.cantidadTotalCanasta += item.quantity;
                        });
                        response.data.tunnel = response.data.cartTunnelData || {};
                        // ===================================================================================================
                        // Load the values for the seller quoting
                        // ===================================================================================================
                        let quoteCartSeller = this.SessionService.get('quoteCartSeller') || null;

                        if (quoteCartSeller) {
                            let itemsQuoteCartSeller = quoteCartSeller.itemsQuoteCartSeller;
                            itemsQuoteCartSeller.forEach(itemSeller => {
                                response.data.items.forEach((item, key) => {
                                    if (item.id === itemSeller.id) {
                                        response.data.items[key].priceItemQuoteSeller = response.data.items[key].priceItemQuoteSeller || 0;
                                        response.data.items[key].ivaPercentageQuoteSeller = item.ivaPercentageQuoteSeller || 0;
                                        response.data.items[key].discountPercentageItemQuoteSeller = itemSeller.discountPercentageItemQuoteSeller || 0;
                                    }
                                });

                            });
                        }
                        this.cart = response.data;
                        resolve(response.data);
                    } else {
                        response.data.items = [];
                        response.data.order = {};
                        response.data.cartQuantity = response.data.cartQuantity || 0;
                        response.data.cartTaxes = response.data.cartTaxes || 0;
                        response.data.cartSubtotal = response.data.cartSubtotal || 0;
                        response.data.cartTotal = response.data.cartTotal || 0;
                        response.data.cartDiscounts = response.data.cartDiscounts || 0;
                        response.data.cartTransports = response.data.cartTransports || 0;
                        this.cart = response.data;
                        resolve(response.data);
                    }
                }).catch(reason => {
                    reject(reason);
                });
            }
        });
    }

    getCartNew(clear) {
        return this.$q((resolve, reject) => {
            let thirdId = this.SharedService.partialConsultThird();
            let userId = this.SharedService.partialConsultUser();
            if (this.cart.cartId && !clear) {
                resolve(this.cart);
            } else {
                let cartSaved = this.AuthTokenFactory.getToken('auth-cart');
                if (!cartSaved) return reject();
                let cart = atob(cartSaved);
                cart = cart.split(':')[0];
                this.$http({
                    method: 'GET',
                    url: this.ngAuthSettings.apiServiceBaseUri + '/cart/obtener-canasta?cartId=' + cart + '&userId=' + (thirdId ? thirdId : userId),
                    cache: false
                }).then((response) => {
                    response.data.id = cart;
                    this.cart = response.data;
                    resolve(response.data);
                }).catch(reason => {
                    reject(reason);
                });
            }
        });
    }

    getCartResumeData(cartId, userId, login = false) {
        return this.$q((resolve, reject) => {
            let url = this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getResumeCart
                + '?cartId=' + cartId + '&userId=' + userId;

            if (login) {
                url += '&login=' + login;
            }

            this.$http({
                method: 'GET',
                url: url,
                cache: false
            }).then((response) => {

                if (!response.data.error) {
                    this.SessionService.put('pickupStore', response.data.pickupStore);
                    this.SessionService.put('cartId', response.data.cartId);
                    if(login){
                      this.SessionService.put('cartUnified', response.data.cartUnified);
                    }
                    response.data.items = [];

                    if (!response.data.itemsCanastaUsuario) {
                        response.data.itemsCanastaUsuario = [];
                    }

                    response.data.itemsCanastaUsuario.forEach(dato => {
                        response.data.items.push(dato);
                    });

                    response.data.cartQuantity = response.data.cartQuantity || 0;
                    this.cart = response.data;
                    resolve(response.data);
                } else {
                    response.data.items = [];
                    response.data.cartQuantity = response.data.cartQuantity || 0;
                    this.cart = response.data;
                    resolve(response.data);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveOrder(cartId, branchId, userId, contact, sellerOfCounter) {
        let data = {
            canastaId: cartId,
            sucursalId: branchId,
            usuarioVendedorId: userId,
            esVentaMostrador: sellerOfCounter
        };
        if (contact) {
            data.contactoNombre = contact.contactoNombre;
            data.contactoEmail = contact.contactoEmail;
            data.contactoTelefono = contact.contactoTelefono;
            data.contactoDireccion = contact.contactoDireccion;
            data.contactoNombreCiudad = contact.contactoNombreCiudad;
        }
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/pedidos/pedidos/crear-pedido',
                // url: this.ngAuthSettings.apiServiceBaseUri + '/pedidos/pedidos/crear-pedido?canastaId=' + cartId + '&sucursalId=' + branchId + '&usuarioVendedorId=' + userId,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                if (!response.data.error) {
                    resolve(response.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    createCartTemplate(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.createCartTemplate,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateCityLocation(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateCityLocation,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    deleteItemFromCart(itemId, cartId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/eliminar-item-canasta',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: $.param({
                    'id_canasta': cartId,
                    'id_producto': itemId,
                })
            }).then((response) => {
                if (!response.data.error) {
                    resolve(response.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }


    updateItemsNotAvailable(product, quantity, userId) {

        let data = {
            'userId': userId,
            'itemId': product.id,
            'cantDisp': product.cantidad,
            'cantSoli': quantity
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/item-info/registrar-venta-perdida',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }


    clearLocalCart() {
        this.cart = null;
    }

    getMethodTransport(){
        
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.locationRuler,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });


    }

    getShippingMethod(cartId,total){

        var  data = {cartId:cartId,total:total};
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                 url: this.ngAuthSettings.apiServiceBaseUri + '/location/get-modalidad-envios',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    saveShipping(data){

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/save-cart-shipping',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    saveWorkingHours(data){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/save-working-hours',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    getShippingRate(id){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/get-tiempo-entrega',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike({id:id})
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    saveDeliveryDay(date,cardId){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/save-delivery-day',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike({deliveryDay:date,cardId:cardId})
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveDiscountCoupon(cartId, userId, couponCode) {
        const URL = `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.validateCuponCode}`
        return this.$http({
            method: 'POST',
            url: URL,
            data: { cartId, userId, couponCode },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    }

    deleteCoupon(couponCode,cartId) {
        const URL = `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.deleteCartCupon}`
        return this.$http({
            method: 'POST',
            url: URL,
            data: { cartId, couponCode },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    }
}

CartService.$inject = inject;

export default CartService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/cart/cart.service.js
 **/